export default "__VITE_ASSET__BjaA2Cpx__"